import { render, staticRenderFns } from "./ZumaLink.vue?vue&type=template&id=6beef7ca&"
import script from "./ZumaLink.vue?vue&type=script&lang=js&"
export * from "./ZumaLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports